import variables from '@/helpers/variables';
import {hashStr, shootConfetti, getCookie, setCookie} from '@/helpers/utils';

const BH = {};

BH.sezame = (password) => {
  const res = variables.sezamePassword === hashStr(password);
  variables.isSezameOpened = res;
  if (res) shootConfetti();
};

BH.switchTheme = (state = undefined) => {
  const cookieName = 'bh_theme';
  const vuetify = window.vuetify;

  if (vuetify) {
    const theme = vuetify.framework.theme;

    if (state !== undefined) {
      theme.dark = state === 'dark';
      setCookie(cookieName, state);
    } else {
      theme.dark = !theme.dark;
      setCookie(cookieName, theme.dark ? 'dark' : 'light');
    }
  } else console.warn('Vuetify instance not available');
};

BH.loadTheme = () => {
  const theme = getCookie('bh_theme');
  if (theme) BH.switchTheme(theme);
};

window.BH = BH;
